import { Select } from 'antd';
import { useEffect, useState } from 'react';
import District from '../../constant/District.json';
import TranslationKey from 'src/i18n/translation';

const { Option } = Select;

interface DistrictProps {
  districtID: number,
  provinceID: number,
  sendProvinceID: (id: number) => void,
  sendDistrictID: (id: number) => void,
  className: string;
}

export default function SelectDistrict(props: DistrictProps) {
  const [districtId, setDistrictId] = useState(0);

  useEffect(() => {
    setDistrictId(props.districtID);
  }, [props.districtID]);

  useEffect(() => {
    if (props.provinceID > 0) {
      if (District.some(d => d.provinceID === props.provinceID && d.id === props.districtID)) {
        setDistrictId(props.districtID);
      }
      else {
        setDistrictId(District.filter(d => d.provinceID === props.provinceID)[0].id);
        props.sendDistrictID(District.filter(d => d.provinceID === props.provinceID)[0].id);
      }
    }

  }, [props.provinceID]);

  const handleChangeDistrict = (value: number) => {
    setDistrictId(value);

    props.sendDistrictID(value);
  };

  return (
    <Select
      style={{ width: '100%' }}
      size="large"
      className={props.className}
      value={districtId}
      onSelect={(value: number) => handleChangeDistrict(value)}
    >
      <Option value={0}>
        {TranslationKey('select')}
      </Option>
      {
        District.map((data, index) => data.provinceID === props.provinceID && (
          <Option value={data.id} key={`${data.id}-${index}`}>
            {data.name}
          </Option>
        ))
      }
    </Select>
  );
}